import { DEFAULT_ERROR_MESSAGE } from '../constants'

export const getFirstErrorMessage = (error) => {
  if (error.response) {
    console.log(error.response)
    if (
      error.response?.data?.errors &&
      error.response?.data?.errors === Object(error.response?.data?.errors)
    ) {
      return arrayError(error.response.data.errors)
    } else if (error.response?.data?.message) {
      return error.response.data.message
    } else if (error.response?.data?.error) {
      if (error.response.data.error === Object(error.response.data.error)) {
        return arrayError(error.response.data.error)
      } else {
        return error.response.data.error
      }
    }
  }
  return DEFAULT_ERROR_MESSAGE
}

export const cleanSession = ($store, $router) => {
  $store.commit('auth/clearData')
  $router.push('/login')
}

const arrayError = (errors) => {
  const firstError = errors[Object.keys(errors)[0]]
  return Array.isArray(firstError) ? firstError[0] : firstError
}
